import { UserState } from '@/types/store/user';
export const state: UserState = {
    userInfo: {},
    isAdmin: false,
    id: -1,
    name: '',
    nickname: '',
    avatar: '',
    phone: '',
    status: '',
    roles: [],
    auths: [],
    orgId: ''
  };